
<div class="nroacc">
    <label class="label-r sidenmbr vcenter w-auto">
        <span class="tabcell">
            N&uacute;mero de Cuenta
        </span>
    </label>
    <div class="autorow subsc  mob-wid pull-right">
        <div *ngIf="this.totalAccountList > 0">
            <select [(ngModel)]="this.selectBan" (change)="this.refreshDataTo($event)" class="sel-f" style="background-image:url(/assets/images/selectabarrw.png)" >
                <option *ngFor="let list of this.currentList" [ngValue]="list.account">{{list.account}}</option>
            </select>
        </div>	
    </div>
</div>